/**
 * The Finger class represents a tracked finger.
 *
 * <p>Fingers are Pointable objects that the Leap has classified as a finger.
 * Get valid Finger objects from a Frame or a Hand object.</p>
 *
 * <p>Note that Finger objects can be invalid, which means that they do not
 * contain valid tracking data and do not correspond to a physical finger.
 * Invalid Finger objects can be the result of asking for a Finger object
 * using an ID from an earlier frame when no Finger objects with that ID
 * exist in the current frame. A Finger object created from the Finger
 * constructor is also invalid.<br/>
 * Test for validity with the <code>Finger.sValid()</code> function.</p>
 *
 * @author logotype
 *
 */
var helpController = (function () {
    function helpController(env, $filter, DTS, $stateParams, $state) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        /**
         * @formvalue for the help texte.
         */
        this.helpText = "hi";
        //console.log(this.$state);
    }
    /**
     * Comment for method ´doSomething´.
     * @param target  Comment for parameter ´target´.
     * @returns       Comment for return value.
     */
    helpController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state'];
    return helpController;
}());
/**
 * Comment for method ´doSomething´.
 * @param target  Comment for parameter ´target´.
 * @returns       Comment for return value.
 */
var helpComponent = (function () {
    function helpComponent() {
        this.templateUrl = 'help.html';
        this.controllerAs = 'vm';
        this.controller = helpController;
    }
    return helpComponent;
}());
angular
    .module('application')
    .component('helpSection', new helpComponent());

//# sourceMappingURL=help.component.js.map
